'use client';

import useEnhancedEffect from '@mui/utils/useEnhancedEffect';
export default useEnhancedEffect;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/useEnhancedEffect.js
// module id = 113
// module chunks = 22